import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useDeleteConfirm } from "../../../../../hooks/useDeleteConfirm"
import { useDeviceRoles } from "../../../../../hooks/useDeviceRoles"
import { DimaFeatureShortNameEnum } from "../../../../models/Authorization"
import { DeviceRoleGet } from "../../../../models/DeviceRole"
import { deleteEntity } from "../../../../utils/deleteEntity"
import { booleanComparator, getDoneIcon, getEmptyIcon } from "../../../../utils/getBooleanFlagIcon"
import { DiMaAddButton } from "../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function DeviceRoles() {
  const { deviceId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()
  const { deviceRoles, isLoadingDeviceRoles } = useDeviceRoles(deviceId)

  const columns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: `/devices/${deviceId}/roles`,
    },
    {
      field: "isDefault",
      headerName: "Is Default",
      renderCell: (row: EntityRow) => row.isDefault ? getDoneIcon() : getEmptyIcon(),
      sortComparator: booleanComparator,
    },
  ]

  const sorted = [...deviceRoles].sort((a, b) =>
    (a.name ?? "").localeCompare(b.name ?? "")
  )

  const rows = sorted.map((role: DeviceRoleGet) => ({
    id: role.id,
    name: role.name,
    isDefault: role.isDefault,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/devices/${deviceId}/roles/create`}
        feature={DimaFeatureShortNameEnum.DM}
      />
    ),
    [deviceId]
  )

  const handleActionMenuClick = useCallback((item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(`/devices/${deviceId}/roles/${row.id}`)
        )
      }
    }, [deviceId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingDeviceRoles}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
